import { render } from "./ScatterChart.vue?vue&type=template&id=3b1a970f&scoped=true&ts=true"
import script from "./ScatterChart.vue?vue&type=script&lang=ts"
export * from "./ScatterChart.vue?vue&type=script&lang=ts"

import "./ScatterChart.vue?vue&type=style&index=0&id=3b1a970f&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1a970f"]])

export default __exports__